// extracted by mini-css-extract-plugin
export default {"cta":"FE-z","disabled":"GE-z"};